import {Component} from '@angular/core';

@Component({
    selector: 'zah-activiteit-header',
    templateUrl: './activiteit-header.component.html',
    styleUrls: ['./activiteit-header.component.scss'],
    standalone: false
})
export class ActiviteitHeaderComponent {
}
